import { render, staticRenderFns } from "./promotional.vue?vue&type=template&id=00e811f0&scoped=true&"
import script from "./promotional.vue?vue&type=script&lang=js&"
export * from "./promotional.vue?vue&type=script&lang=js&"
import style0 from "./promotional.vue?vue&type=style&index=0&id=00e811f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e811f0",
  null
  
)

export default component.exports